import React from "react";

const LOGO_URL = "/mamta-logo.png";

export function Logo({ className = "", showText = false, variant = "dark", size = 44 }) {
  const isLight = variant === "light";
  return (
    <a
      href="/"
      className={`inline-flex items-center ${className} ${isLight ? "bg-white rounded-2xl px-3 py-1.5 shadow-[0_8px_24px_-6px_rgba(0,0,0,0.35)]" : ""}`}
      data-testid="site-logo"
      aria-label="Mamta Tours & Travels"
    >
      <img
        src={LOGO_URL}
        alt="Mamta Tours & Travels"
        style={{ height: size }}
        className="w-auto select-none"
        loading="eager"
        decoding="async"
      />
    </a>
  );
}
